export const environment = {
	production: false,
	authLayer_staging: 'https://viey4lpjrre2dpkldbqhoo6pby.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
	authLayer_release: 'https://a3ws6pttlzc7flsoyuudnmzurm.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
	abstractionLayerStagingUrl: 'https://fabpu7q5onailaaz3eb2jq2lm4.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
	abstractionLayerReleaseUrl: 'https://wjbw5doijnhwfksoq3bwv7cyn4.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
	requirementsurl: 'https://polarion-dev.scania.com/polarion/#/',
	redirect_url: 'https://start.testtools.dev.scania.com.cn/login',
	auth_provider: 'azure',
	auth_client_id: '2720a135-3c4c-43b5-bbc8-dc84d23f97ab',
	auth_url: 'https://login.partner.microsoftonline.cn/e71a154e-e269-46af-a3af-fdff3eab0663/oauth2/v2.0/authorize',
	auth_response_mode: 'query',
	auth_scope: 'api://2720a135-3c4c-43b5-bbc8-dc84d23f97ab/All',
	logConfig: {
		application: 'testtools',
		env: 'dev',
		graphqlUrl: 'https://4wu25lkmsreufnzqpwkuku77my.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
		logLevel: 2,
		console: true,
		debounceTime: 5000,
	},
	launchDarklyClientId: '664590c02c638010dc55095f',
	deliveryDatabase_url: 'https://ddb.testtools.dev.scania.com.cn',
	configurator_url: 'https://configurator.testtools.dev.scania.com.cn',
	executor_url: 'https://executor.testtools.dev.scania.com.cn',
	results_url: 'https://results.testtools.dev.scania.com.cn',
	reports_url: 'https://reports.testtools.dev.scania.com.cn',
	vehicle_bookings_url: 'https://testtools.testtools.devtest.gf.aws.scania.com',
	ecu_compare_url: 'https://ecucompare.testtools.dev.scania.com.cn',
	parentDomain: '.testtools.dev.scania.com.cn',

	environment: 'hero',
	serviceWorkerEnabled: true,
};
